import React, { useEffect } from 'react';
import { ArrowRight, MessageSquareReply, Newspaper, Search } from 'lucide-react';
import markLogo from 'src/assets/branding/auto-appy-mark-256x256.png';
import { useAuth } from 'src/context/AuthContext';

const SAMPLE = process.env.REACT_APP_DEV_LOGIN === 'true';

/** Signed-out screen. Production goes straight to Auto Appy sign-in. */
export default function SignInPage({ onSignIn, offline }) {
  const { signInSample } = useAuth();
  useEffect(() => {
    if (!SAMPLE && !offline) onSignIn();
  }, [offline, onSignIn]);

  return (
    <div className="mx-boot mx-signin">
      <img src={markLogo} alt="" />
      <strong>Auto Appy Google My Business</strong>
      <span>Reply to every Google review, post every week and climb higher on Google Maps, all from one place.</span>
      <ul className="mx-signin-points">
        <li><MessageSquareReply size={16} aria-hidden="true" />Replies in your customer’s language</li>
        <li><Newspaper size={16} aria-hidden="true" />Posts, offers and holiday hours on schedule</li>
        <li><Search size={16} aria-hidden="true" />Profile score and Maps rank grid</li>
      </ul>
      {offline && <span className="mx-signin-warn">Auto Appy cannot be reached right now. Check your connection and try again.</span>}
      <button type="button" className="ws-btn ws-btn--primary ws-btn--lg" onClick={onSignIn}>Sign in with Auto Appy <ArrowRight size={16} aria-hidden="true" /></button>
      {SAMPLE && (
        <div className="mx-signin-sample">
          <span>Local development</span>
          <button type="button" className="ws-btn ws-btn--quiet" onClick={() => signInSample('owner')}>Sample owner</button>
          <button type="button" className="ws-btn ws-btn--quiet" onClick={() => signInSample('member')}>Sample member</button>
        </div>
      )}
    </div>
  );
}
